import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Workbench from "./pages/Workbench";
import LeadDetail from "./pages/LeadDetail";
import BulkImport from "./pages/BulkImport";
import Reports from "./pages/Reports";
import AdminMasters from "./pages/AdminMasters";
import AdminUsers from "./pages/AdminUsers";
import AdminApiKeys from "./pages/AdminApiKeys";
import AdminEmailTemplates from "./pages/AdminEmailTemplates";
import AdminStageEmailRules from "./pages/AdminStageEmailRules";
import AdminTargets from "./pages/AdminTargets";
import TargetAchievement from "./pages/TargetAchievement";
import Settings from "./pages/Settings";
import PublicForm from "./pages/PublicForm";
import MyDay from "./pages/MyDay";
import AdminAgent from "./pages/AdminAgent";
import AgentCallHistory from "./pages/AgentCallHistory";
import "./App.css";

function Protected({ children }) {
  const { user, bootstrapped } = useAuth();
  if (!bootstrapped) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div className="text-sm text-slate-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/form" element={<PublicForm />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/my-day" element={<Protected><MyDay /></Protected>} />
            <Route path="/leads" element={<Protected><Workbench /></Protected>} />
            <Route path="/leads/:id" element={<Protected><LeadDetail /></Protected>} />
            <Route path="/bulk-import" element={<Protected><BulkImport /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/reports/target-vs-achievement" element={<Protected><TargetAchievement /></Protected>} />
            <Route path="/admin/targets" element={<Protected><AdminTargets /></Protected>} />
            <Route path="/admin/masters" element={<Protected><AdminMasters /></Protected>} />
            <Route path="/admin/users" element={<Protected><AdminUsers /></Protected>} />
            <Route path="/admin/api-keys" element={<Protected><AdminApiKeys /></Protected>} />
            <Route path="/admin/email-templates" element={<Protected><AdminEmailTemplates /></Protected>} />
            <Route path="/admin/stage-email-rules" element={<Protected><AdminStageEmailRules /></Protected>} />
            <Route path="/admin/agent" element={<Protected><AdminAgent /></Protected>} />
            <Route path="/admin/agent/call-history" element={<Protected><AgentCallHistory /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
